module.exports = __webpack_public_path__ + "img/feature.cb66a6a9.png";